import { useAuth } from "../contexts/AuthProvider/AuthProvider";

export const useLoggedInUserInfo = () => {
  const userInfo = useAuth().userInfo.user;
  return userInfo;
};
